import { useEffect } from 'react';

export const useRecaptchaBadge = shouldHide => {
  // reCAPTCHAバッジの表示/非表示を制御
  useEffect(() => {
    const updateBadgeVisibility = () => {
      const badge = document.querySelector('.grecaptcha-badge');
      if (badge) {
        if (shouldHide) {
          badge.classList.add('hidden-on-hero');
        } else {
          badge.classList.remove('hidden-on-hero');
        }
      }
    };

    // バッジの生成を監視
    const checkBadge = () => {
      const badge = document.querySelector('.grecaptcha-badge');
      if (badge) {
        updateBadgeVisibility();
      } else {
        // バッジがまだ生成されていない場合は、少し後に再チェック
        setTimeout(checkBadge, 100);
      }
    };

    checkBadge();
  }, [shouldHide]);

  // reCAPTCHAバッジの初期化を監視
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const badge = document.querySelector('.grecaptcha-badge');
      if (badge) {
        if (shouldHide) {
          badge.classList.add('hidden-on-hero');
        } else {
          badge.classList.remove('hidden-on-hero');
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [shouldHide]);
};
